import { gql, useQuery } from "@apollo/client";
import React from "react";
import styled from "styled-components";
import RelatedRecordCardData from "../../LeadDetail/CustomObjectRelatedRecordData";

const FETCH_CUSTOM_OBJECT_SUMMARY = gql`
  query fetchAssociatedCustomObjects($lead_id: String!) {
    fetchAssociatedCustomObjects(lead_id: $lead_id) {
      id
      name
      association_count
    }
  }
`;

interface IRelatedRecordsTab {
  maxHeight: number;
  leadId: string;
}

export const RelatedRecordsTab: React.FC<IRelatedRecordsTab> = ({ maxHeight, leadId }) => {
  const { data: dataCustomObjectSummary, loading: loadingCustomObjectSummary } = useQuery(FETCH_CUSTOM_OBJECT_SUMMARY, {
    fetchPolicy: "network-only",
    variables: {
      lead_id: leadId,
    },
    skip: !leadId,
    onError({ message, name }) {
      console.log(`Error in ${name}: `, message);
    },
  });

  return (
    <Wrapper maxHeight={maxHeight}>
      <Container>
        <RelatedRecordCardData
          lead_id={leadId}
          customObjectSummary={dataCustomObjectSummary?.fetchAssociatedCustomObjects}
        />
      </Container>
    </Wrapper>
  );
};

const Wrapper = styled.div<{ maxHeight?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;

  width: 100%;

  height: 100%;
  max-height: ${({ maxHeight }) => (maxHeight ? `${maxHeight}px` : "100%")};

  overflow-y: auto;
`;

const Container = styled.div`
  position: relative;

  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 70%;
  max-width: 784px;
  min-width: 330px;

  padding: 16px 0px;
`;
